import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getCustomerDetails } from "../../../api/endpoints/customer";


const CustomerFormModal = ({ show, onClose, onSave, compId, customerId }) => {
  const [form, setForm] = useState({
    comp_id:  "",
    customer_id : "",
    first_name: "",
    last_name: "",
    company_name: "",
    password: "",
    email: "",
    mobile: "",
    customer_gst: "",
    customer_address: "",
    customer_billing: "",
    max_devices: "",
  });

  const [validated, setValidated] = useState(false);
  const isEdit = !! customerId;

  useEffect(() => {
    const fetchData = async () => {
      if (isEdit && show) {
        try {
          const response = await getCustomerDetails(compId, customerId);
          if (response.status === 200) {
            const data = response.data.data;
            setForm({
              comp_id:  compId,
              customer_id : customerId,
							first_name:  data.customer_first_name || "",
    					last_name:  data.customer_last_name || "",
              company_name: data.customer_company_name || "",
              customer_gst : data.customer_gst || "",
              email_id: data.email_id || "",
              mobile: data.customer_mobile || "",
              customer_address: data.customer_address || "",
              customer_billing: data.customer_billing_email_id || "",
              customer_status: data.customer_status ? "Active": "Block" || "Block",
            });
          }
        } catch (err) {
          console.error("Error fetching customer:", err);
        }
      } else {
        setForm({
          customer_id: "",
					first_name: "",
					last_name: "",
					company_name: "",
					password: "",
					email: "",
					mobile: "",
					customer_gst: "",
					customer_address: "",
					customer_billing: "",
        });
      }
    };
    fetchData();
  }, [customerId, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    onSave(form);
    onClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">{isEdit ? "Edit Customer" : "Add Customer"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
					<form onSubmit={handleSubmit} 
					className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
					noValidate
					autoComplete="off">
						<div className="modal-body">
							<div className="row">
								{isEdit && (
									<>
										<div className="col-12">
											<div className="mb-3">
												<label className="form-label">Company ID</label>
												<input type="text" className="form-control-plaintext cursor-default bg-gray-100" value={form.comp_id} readOnly />
											</div>
										</div>
										<div className="col-12">
											<div className="mb-3">
												<label className="form-label">Customer ID</label>
												<input type="text" className="form-control-plaintext cursor-default bg-gray-100" value={form.customer_id} readOnly />
											</div>
										</div>
									</>
								)}
								<div className="col-6">
									<div className="mb-3">
										<label for="personNameinput" className="form-label">Customer First Name</label>
										<input type="text" name="first_name" className="form-control" placeholder="Enter customer first name" id="personNameinput" value={form.first_name} onChange={handleChange} required/>
										<div className="invalid-feedback">Please enter customer first name.</div>
									</div>
								</div>
								<div className="col-6">
									<div className="mb-3">
										<label for="personLastNameinput" className="form-label">Customer Last Name</label>
										<input type="text" name="last_name" className="form-control" placeholder="Enter customer last name" id="personLastNameinput" value={form.last_name} onChange={handleChange} required/>
										<div className="invalid-feedback">Please enter customer last name.</div>
									</div>
								</div>
								<div className="col-12">
									<div className="mb-3">
										<label for="compNameinput" className="form-label">Company Name</label>
										<input type="text" name="company_name" className="form-control" placeholder="Enter company name" id="compNameinput" value={form.company_name} onChange={handleChange} required />
										<div className="invalid-feedback">Please enter company name.</div>
									</div>
								</div>
								<div className="col-6">
									<div className="mb-3">
										<label for="phonenumberInput" className="form-label">Mobile Number</label>
										<input type="tel" name="mobile" className="form-control" placeholder="99999999999" id="phonenumberInput" value={form.mobile} onChange={handleChange} required/>
										<div className="invalid-feedback">Please enter mobile number.</div>
									</div>
								</div>
								{isEdit && (
									<div className="col-6">
										<div className="mb-3">
											<label for="emailidInput" className="form-label">Email Address / Username</label>
											<input type="email" className="form-control-plaintext" placeholder="example@gamil.com" id="emailidInput" value={form.email_id}  readonly/>
										</div>
									</div>
								)}
								{!isEdit && (
									<>
										<div className="col-6">
											<div className="mb-3">
												<label for="emailidInput" className="form-label">Email Address / Username</label>
												<input type="email" name="email" className="form-control" placeholder="example@gamil.com" id="emailidInput" onChange={handleChange} required/>
												<div className="invalid-feedback">Please enter mobile number.</div>
											</div>
										</div>
										<div className="col-12">
											<div className="mb-3">
												<label for="passwordInput" className="form-label">Customer Login Password</label>
												<input type="password" name="password" className="form-control" placeholder="Enter Password" minLength={8} maxLength={16} id="passwordInput" onChange={handleChange} required/>
												<div className="invalid-feedback">Please enter password.</div>
											</div>
										</div>
									</>
								)}
								<div className="col-6">
									<div className="mb-3">
										<label for="compnayGSTinput" className="form-label">Company GST Number</label>
										<input type="text" name="customer_gst" className="form-control" placeholder="Enter company GST no." id="compnayGSTinput" value={form.customer_gst} onChange={handleChange}/>
									</div>
								</div>
								<div className="col-6">
									<div className="mb-3">
										<label for="billingMailInput" className="form-label">Billing Email Id</label>
										<input type="text" name="customer_billing" className="form-control" placeholder="Enter company billing mail id" id="billingMailInput" value={form.customer_billing} onChange={handleChange} required/>
										<div className="invalid-feedback">Please enter billing mail id.</div>
									</div>
								</div>
								<div className="col-12">
									<div className="mb-3">
										<label for="address1ControlTextarea" className="form-label">Address</label>
										<input type="text" name="customer_address" className="form-control" placeholder="Enter Address" id="address1ControlTextarea" value={form.customer_address} onChange={handleChange} required/>
										<div className="invalid-feedback">Please enter address.</div>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="text-end">
										<button type="button" className="btn btn-light me-2" onClick={onClose}>
												Close
										</button>
										<button type="submit" className="btn btn-success">Submit</button>
									</div>
								</div>
							</div>
						</div>
					</form>
        </div>
      </div>
    </div>
  );
};

CustomerFormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  customerId: PropTypes.string,
  compId: PropTypes.string,
};

export default CustomerFormModal;